import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { TgEmoji } from "@/components/TgEmoji";
import { popupActionsCol, popupBtnPrimary } from "@/lib/popupButtons";
import { PopupCloseButton } from "@/components/PopupClose";
import type { QuestItemOut } from "@/api/types";

/**
 * Попап «Квест виконано» в апці (юзер 2026-06-25): анімований емодзі +
 * заголовок + назва квесту + сума бонусу + кнопка «Перейти до бонусів».
 * Стиль 1:1 з SubscriptionActivatedModal (центрований, rounded-3xl).
 */
export function QuestCelebrationModal({
  quest,
  onClose,
}: {
  quest: QuestItemOut;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-xs bg-surface rounded-3xl p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <PopupCloseButton onClose={onClose} />
        <div className="text-center mb-4">
          <div className="mb-2 flex justify-center">
            {/* Анімований Lottie 🥇 (сам лупиться). 🏆 у Telegram майже без руху. */}
            <TgEmoji char="🥇" size={52} />
          </div>
          <div className="font-display text-[1.125rem] font-bold text-ink leading-tight mb-1.5">
            Квест виконано!
          </div>
          <div className="text-[0.84375rem] text-ink leading-relaxed">
            «{quest.title}»
          </div>
          <div className="mt-2 inline-flex items-center gap-1 rounded-full bg-primary/10 px-3 py-1 font-display text-[0.8125rem] font-bold text-primary">
            +{quest.reward_uah} грн
          </div>
        </div>
        <div className={popupActionsCol}>
          <button
            type="button"
            onClick={() => {
              onClose();
              navigate("/quests");
            }}
            className={popupBtnPrimary}
          >
            Перейти до бонусів →
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
